import { createAsyncThunk } from "@reduxjs/toolkit";
import apiClient from "../../API/apiClient";

export const getAllReport = createAsyncThunk(
    'ledgerStatement/fetchAllReport',
    async (_, { rejectWithValue }) => {
      try {        
        const response = await apiClient.get('Report/GetAllReports');
        return response.data;  
      } catch (error) {
        return rejectWithValue(error.response?.data || 'Error fetching data');
      }
    }
  );
  
  export const getReportId = createAsyncThunk(
    'ledgerStatement/fetchReportId',
    async ({ ReportId }, { rejectWithValue }) => {
      try {        
        const response = await apiClient.get(`Report/GetReportsById?ReportId=${ReportId}`);
        return response.data;  
      } catch (error) {
        return rejectWithValue(error.response?.data || 'Error fetching data');
      }
    }
  );

  export const getReportData = createAsyncThunk(
    'ledgerStatement/fetchReportData',
    async ({ reportId,values }, { rejectWithValue }) => {
      console.log("reportId",reportId);
      console.log("values",values);
      try {        
        const response = await apiClient.get(`Report/ReportData?reportId=${reportId}&values=${values}`);
        return response.data;  
      } catch (error) {
        return rejectWithValue(error.response?.data || 'Error fetching data');
      }
    }
  );